import "./src/global.css";
import React from "react";

// Lazy-load CookieYes AFTER Gatsby hydrates
export const onInitialClientRender = () => {
  const script = document.createElement("script");
  script.id = "cookieyes";
  script.type = "text/javascript";
  script.src =
    "https://cdn-cookieyes.com/client_data/01f364a57d440a81ddded5af/script.js";
  script.defer = true;

  document.body.appendChild(script);
};
